declare global {
	interface Window {
		umami: Umami
	}
}

type UmamiPayload = {
	hostname: string
	language: string
	referrer: string
	screen: string
	title: string
	url: string
	website: string
}

type Umami = {
	track: typeof track
	identify: typeof identify
}

export function track(payload: Record<string, unknown>): void
export function track(eventName: string, eventData?: Record<string, unknown>): void
export function track(fn: (payload: UmamiPayload) => Record<string, unknown>): void
export function track(...args: Array<any>): void {
	if (typeof args[0] === 'string') args[1] = args[1] ?? {}
	return (window.umami?.track as any)?.(...args)
}

export function identify(session_data: Record<string, unknown>): void {
	return (window.umami?.identify as any)?.(session_data)
}

export const umami = { track, identify }
